import styled from 'styled-components'

export const SessionWrapper = styled.div`
  height: 100vh;
  max-width: ${({ theme }) => theme.sizes.sessionDetailsCardMaxWidth}px;
  overflow-y: auto;
  position: relative;
  width: 100%;
`
